export const Colors: any = {
  primaryColor: '#009AC5',
  secondaryColor: '#0D316E',
  logoutColor: '#929CAC',
  backgroundColor: '#0F252E',
  textColor: '#000000',
  filetextColor: '#4997b2',
  textColorSecondary: '#fff',
  tagDefaultBg: '#e6f7ff',
  headerColor: '#fff',
  errorColor: '#C46547',
  cardBackgroundColor: '#ebf1f0',
  fileExcelFilledColor: '#1d6f42',
  filePptFilledColor: '#d04423',
  filePdfFilledColor: '#f40f02',
  fileWordFilledColor: '#005da6',
  broadcastNotificationColor: '#1890ff',
  editBoxColor: '#F9F8F6',
  userChatBoxBgColor: '#009AC5',
  botChatBoxBgColor: '#FFFFFF',
  msgTrendLineTokenColor: '#78c867',
  wordCloudColor1: '#40a2ff',
  wordCloudColor2: '#13c2c2',
  wordCloudColor3: '#50cb73',
  wordCloudColor4: '#A0D911',
  wordCloudColor5: '#fbd445',
  wordCloudColor6: '#FAAD14',
  wordCloudColor7: '#FF745A',
  wordCloudColor8: '#f2637b',
  wordCloudColor9: '#9761e5',
  wordCloudColor10: '#91d5ff',
  wordCloudColor11: '#87e8de',
  wordCloudColor12: '#b7eb8f',
  wordCloudColor13: '#fffb8f',
  wordCloudColor14: '#ffd591',
  wordCloudColor15: '#ffa39e',
  wordCloudColor16: '#ffadd2',
  wordCloudColor17: '#d3adf7',
  wordCloudColor18: '#bfbfbf',
  fileFolderMouseEnterColor: '#ededed',
  fileFolderMouseLeaveColor: 'rgba(0, 0, 0, 0)',
  fileSiderBgColor: '#edeff0',
  fileGroupBgColor: '#ECEDE6',
  fileRevisionHistoryUsernameBgColor: '#5abfc0',
  fileRevisionHistoryActionTextColor: '#f4f4f4',
  fileRevisionCharacterLimitTextColor: '#ccc',
  hoverBackgroundColor: '#0B1B22',
  leftSideBackground: '#e8ecf2',
};
